import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Lock, CreditCard, ShieldCheck } from 'lucide-react';
export function PurchaseSection() {
  return <div id="purchase" className="py-16 px-4 bg-gradient-to-b from-purple-50 to-white" data-id="element-19">
      <div className="max-w-3xl mx-auto" data-id="element-20">
        <motion.div initial={{
        scale: 0.95,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} className="bg-white rounded-3xl shadow-2xl overflow-hidden border-4 border-purple-200" data-id="element-21">
          <div className="bg-gradient-to-r from-purple-600 to-pink-500 p-6 text-center text-white" data-id="element-22">
            <h2 className="text-3xl font-bold mb-2" data-id="element-23">
              Oferta Especial Limitada
            </h2>
            <p className="opacity-90" data-id="element-24">
              Acceso inmediato + Todos los bonos de regalo
            </p>
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-25">
            <div className="mb-8" data-id="element-26">
              <span className="text-gray-400 text-xl line-through mr-3" data-id="element-27">
                $47 USD
              </span>
              <div className="flex items-center justify-center gap-1 text-purple-900" data-id="element-28">
                <span className="text-3xl font-bold" data-id="element-29">$</span>
                <span className="text-7xl font-extrabold tracking-tight" data-id="element-30">
                  9,97
                </span>
                <span className="text-xl font-medium self-end mb-4" data-id="element-31">USD</span>
              </div>
            </div>

            <motion.a href="Link de tu checkout" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="block w-full bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white font-bold text-xl md:text-2xl py-5 px-8 rounded-xl shadow-lg hover:shadow-xl transition-all mb-6 flex items-center justify-center gap-3" data-id="element-32">
              <span data-id="element-33">QUIERO DECIR NO SIN SENTIRME MALA</span>
              <ArrowRight className="w-6 h-6" data-id="element-34" />
            </motion.a>

            <div className="flex flex-col md:flex-row items-center justify-center gap-6 text-sm text-gray-500 mt-8 border-t border-gray-100 pt-6" data-id="element-35">
              <div className="flex items-center gap-2" data-id="element-36">
                <Lock className="w-4 h-4" data-id="element-37" />
                <span data-id="element-38">Pago 100% Seguro</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-39">
                <CreditCard className="w-4 h-4" data-id="element-40" />
                <span data-id="element-41">Acceso Inmediato</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-42">
                <ShieldCheck className="w-4 h-4" data-id="element-43" />
                <span data-id="element-44">Garantía de Satisfacción</span>
              </div>
            </div>
          </div>
        </motion.div>

        <p className="text-center text-gray-500 text-sm mt-8 max-w-xl mx-auto" data-id="element-45">
          Al hacer clic serás redirigida a nuestra pasarela de pago segura. El
          precio está en dólares pero se convertirá automáticamente a tu moneda
          local.
        </p>
      </div>
    </div>;
}